import React, { useEffect, useState } from 'react'
import { Col, Form, Row, Spinner } from 'react-bootstrap'
import CustomButton from '../common/CustomButton'
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import ArrowCircleLeftRoundedIcon from '@mui/icons-material/ArrowCircleLeftRounded';
import CustomTextFeild from '../common/CustomTextFeild'
import { useNavigate, useParams } from 'react-router-dom';
import { apiRequest } from '../utils/config/apiRequest';
import { _apiUrls } from '../utils/endpoints/apiUrls';
import CustomTextArea from '../common/CustomTextArea';
import { showMessage } from '../utils/helpers/toastHelpers';
import { validateCategoryForm } from '../common/Validation';
import { getTheme } from '../redux/selectors/appSelectors';
import { useSelector } from 'react-redux';
import { compressImageIfNeeded } from '../utils/endpoints/filehelper';

export default function AddCategory() {

    const theme = useSelector(getTheme);
    const isDarkMode = theme === 'dark';

    const navigate = useNavigate();
    const { id } = useParams();

    const isEditMode = Boolean(id);

    const [categoryStatus, setCategoryStatus] = useState('');
    const [errors, setErrors] = useState({});

    const [state, setState] = useState({
        categoryName: '',
        categoryIcons: null,
        description: '',
    });

    const [load, setLoad] = useState(false);
    const [loadingData, setLoadingData] = useState(false);

    const handleChange = (value) => {
        setCategoryStatus(value.toLowerCase());
    };

    // Add Edit -------------------------------------------------

    const fetchCategoryDetails = async () => {
        setLoadingData(true);
        const { data, status, message } = await apiRequest({
            endUrl: _apiUrls.getCategory,
            method: 'GET',
            query: { categoryId: id },
        });
        setLoadingData(false);
        const catUser = data


        if (status && catUser) {
            setState({
                categoryName: catUser?.categoryName,
                categoryIcons: catUser?.categoryIcons,
                description: catUser?.description,
            });
            setCategoryStatus(catUser?.status?.toLowerCase());
        } else {
            showMessage({ message: message });
        }
    };

    useEffect(() => {
        if (isEditMode) {
            fetchCategoryDetails();
        }
    }, [id]);


    const handlePublish = async () => {

        const validationErrors = validateCategoryForm(state, categoryStatus);
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;

        const compressedIcon = await compressImageIfNeeded(state?.categoryIcons);

        setLoad(true);
        const formData = new FormData();
        formData.append('categoryName', state?.categoryName);
        formData.append('categoryIcons', compressedIcon);
        formData.append('description', state?.description);
        formData.append('status', categoryStatus);


        const { status } = await apiRequest({
            endUrl: isEditMode ? _apiUrls.updateCategory : _apiUrls.addCategory,
            method: isEditMode ? 'PUT' : 'POST',
            body: formData,
            headerType: 'form',
            query: isEditMode ? { categoryId: id } : {},
            showMsg: true
        });
        setLoad(false);
        if (status) {
            navigate('/dashboard/categories');
        }
    };

    return (
        <>

            <Row className='align-items-start'>
                <Col md={8} className='py-1'>
                    <h4 className='dashheading'>Add Category Management</h4>
                    <p className='dashsubheading'>Add/Edit Category Management</p>
                </Col>
                <Col md={4} className='py-1'>
                    <div className="d-flex justify-content-end align-items-center gap-2">
                        <CustomButton variant="contained"
                            text={load ? <Spinner size="sm" animation="border" /> : "Publish"}
                            iconLeft={!load && <CheckBoxOutlinedIcon style={{ fontSize: 18 }} />}
                            className='containebtn'
                            onClick={handlePublish}
                            // disabled={load}
                            style={{ width: 100 }}
                        />
                        <CustomButton variant="outline3"
                            text={"Cancel"}
                            iconLeft={<ArrowCircleLeftRoundedIcon style={{ fontSize: 18, color: isDarkMode ? '#fff' : '#fff' }} />}
                            className='outline-btn'
                            onClick={() => navigate('/dashboard/categories')}
                        />
                    </div>
                </Col>
            </Row>

            <Row>
                <Col md={8} className='py-1'>
                    <Row>
                        <Col md={12} className='pb-3'>
                            <p className='mb-1 input-label head-border'>Enter the details below for create/edit Category Management</p>
                        </Col>

                        <Col md={6}>
                            <p className='mb-1 input-label'>Category Name  <span style={{ color: 'red' }}>*</span></p>
                            <CustomTextFeild style={{
                                padding: "9px 11px",
                                borderRadius: "10px",
                            }}
                                placeholder='Enter Category Name'
                                value={state?.categoryName}
                                onChange={(e) => setState({ ...state, categoryName: e.target.value })}
                            />
                            {errors.categoryName && <small style={{ color: 'red', fontSize: 13 }}>{errors.categoryName}</small>}
                        </Col>
                        <Col md={6}>
                            <p className='mb-1 input-label'>Category icons <span style={{ color: 'red' }}>*</span></p>
                            <Form.Group controlId="formFile">
                                <Form.Control
                                    type="file"
                                    onChange={(e) => setState({ ...state, categoryIcons: e.target.files[0] })}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #ccc',
                                        borderRadius: '10px',
                                    }}
                                    className='fileInput'
                                />
                                {isEditMode && state.categoryIcons && (
                                    <div className="mt-3">
                                        <img
                                            src={
                                                state.categoryIcons instanceof File
                                                    ? URL.createObjectURL(state.categoryIcons)
                                                    : `${process.env.REACT_APP_API_ORIGIN}/${state.categoryIcons?.replace(/^\/+/, "")}`
                                            }

                                            alt=""
                                            style={{
                                                width: 100,
                                                height: 100,
                                                borderRadius: '10px',
                                                objectFit: 'cover',
                                                border: '1px solid #ddd'
                                            }}
                                        />
                                    </div>
                                )}
                            </Form.Group>
                            {errors.categoryIcons && <small style={{ color: 'red', fontSize: 13 }}>{errors.categoryIcons}</small>}
                        </Col>

                        <Col md={6} className='mt-3'>
                            <p className='mb-1 input-label'>Description <span style={{ color: 'red' }}>*</span></p>
                            <CustomTextArea
                                placeholder="Enter Description"
                                value={state?.description}
                                onChange={(e) => setState({ ...state, description: e.target.value })}
                            />
                            {errors.description && <small style={{ color: 'red', fontSize: 13 }}>{errors.description}</small>}
                        </Col>
                    </Row>
                </Col>

                <Col md={4}>
                    <div className="status-card">
                        <h5 className="status-title">Status Update</h5>
                        <div className="status-option mb-3 mt-4">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                <input
                                    type="checkbox"
                                    checked={categoryStatus === 'active'}
                                    onChange={() => handleChange('active')}
                                />
                                <p className='mb-0'>Active</p>
                            </div>
                        </div>
                        <div className="status-option">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                <input
                                    type="checkbox"
                                    checked={categoryStatus === 'inactive'}
                                    onChange={() => handleChange('inactive')}
                                />
                                <p className='mb-0'>InActive</p>
                            </div>
                        </div>
                    </div>
                    {errors.status && (
                        <small style={{ color: 'red', display: 'block', marginTop: '8px' }}>
                            {errors.status}
                        </small>
                    )}
                </Col>
            </Row>
        </>
    )
}
